import { TaskType } from "../../../../../types";
import SubWorkflowIcon from "./icons/SubWorkflow";
import TerminateIcon from "./icons/Terminate";
import DynamicFanoutIcon from "./icons/DynamicFanout";
import WaitIcon from "./icons/WaitIcon";
import ForkIcon from "./icons/ForkIcon";

const CardIcon = ({ type }: { type: TaskType }) => {
  return [
    TaskType.WAIT,
    TaskType.FORK_JOIN,
    TaskType.JOIN,
    TaskType.TERMINATE,
    TaskType.SUB_WORKFLOW,
    TaskType.FORK_JOIN_DYNAMIC,
  ].includes(type) ? (
    <div
      style={{
        color: "#ffffff",
        paddingRight: "10px",
      }}
    >
      {type === TaskType.WAIT ? <WaitIcon size={24} /> : null}
      {[TaskType.FORK_JOIN, TaskType.JOIN].includes(type) ? (
        <ForkIcon size={24} />
      ) : null}
      {type === TaskType.TERMINATE ? <TerminateIcon size="24" /> : null}
      {type === TaskType.SUB_WORKFLOW ? <SubWorkflowIcon size="24" /> : null}
      {type === TaskType.FORK_JOIN_DYNAMIC ? (
        <DynamicFanoutIcon size="24" />
      ) : null}
    </div>
  ) : null;
};

export default CardIcon;
